import { defineMessages } from 'react-intl';

export default defineMessages({
  invalid: {
    id: 'app.components.FlexChoices.invalid',
    defaultMessage: 'Item obrigatório',
  },
  areaCode: {
    id: 'app.components.SpacedInput.areaCode',
    defaultMessage: 'DDD',
  },
  descricaoImovel: {
    id: 'app.components.SpacedInput.descricaoImovel',
    defaultMessage: 'Descreva melhor o imóvel (opcional)',
  },
  name: {
    id: 'app.components.SpacedInput.name',
    defaultMessage: 'Nome',
  },
  phoneNumber: {
    id: 'app.components.SpacedInput.phoneNumber',
    defaultMessage: 'Telefone',
  },
  photoSessionNotes: {
    id: 'app.components.SpacedInput.photoSessionNotes',
    defaultMessage: 'Observações sobre a sessão',
  },
});
